/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function PlayIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "play", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M9 19V6L19 12.5L9 19Z", fill: "currentColor" })));
}
const ForwardRef = React.forwardRef(PlayIcon);
export default ForwardRef;
//# sourceMappingURL=playIcon.js.map